__turbopack_context__.v({
  "container": "TransparentRedirectView-module__yn85Ca__container",
  "fadeIn": "TransparentRedirectView-module__yn85Ca__fadeIn",
  "logoSpace": "TransparentRedirectView-module__yn85Ca__logoSpace",
});
